import { connect } from 'react-redux';
import {
  getAWSRegion,
  getAWSAccount,
  getAWSAllRegions,
  getAWSAllAccounts,
  getGrandTotals

} from './../reducers';
import { setAwsPageInfo } from './../actions';
import { aws } from './../helpers';

import AWSSelectorComponent from './../Components/AWSSelectorComponent.jsx';

export const mapStateToProps = (state) => {
  const region = getAWSRegion(state);
  const account = getAWSAccount(state);
  const allRegions = [aws.DEFAULTREGION, ...getAWSAllRegions(state)];
  const allAccounts = [aws.DEFAULTACCOUNT, ...getAWSAllAccounts(state)];
  const grandTotals = getGrandTotals(state);

  return {
    region,
    account,
    allRegions,
    allAccounts,
    grandTotals
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: awsPageInfo => {
    dispatch(setAwsPageInfo(awsPageInfo));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AWSSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/AWSSelectorContainer.jsx